<template>
    <!-- 改行に合わせて伸縮するテキストエリア -->
    <textarea style="overflow-y:hidden" ref="textarea" type="text" :maxlength="maxlength" v-model="input" :disabled="disabled"
        :readonly="readonly" :placeholder="placeholder" :rows="rows"
        @input="inputed" @keydown="keydowned"></textarea>
</template>

<script>
export default {
    props: {
        maxlength: {
            default: "-1"
        },
        disabled: {
            default: false,
        },
        readonly:{
            default: false,
        },
        placeholder:{
            default: ""
        },
        rows:{
            default: -1
        },
        acceptWrap:{
            default: true
        },
        value: {
            default: "",
        },
    },
    data() {
        return {
            input: "",
        }
    },
    watch:{
        value:{
            handler(val){
                this.input = val
            },
            immediate: true,
        }
    },
    updated(){
        this.stretch()
    },
    methods: {
        inputed(){
            if(!this.acceptWrap && /[\n\r]/.test(this.input)){
                this.input = this.input.replace(/[\n\r]/g, "")
            }
            if(this.input != this.value){
                this.$emit("input", this.input)
            }
            this.stretch()
        },
        stretch(){
            let tar = this.$refs["textarea"]
            tar.style["height"] = "auto"
            let borderH = tar.offsetHeight - tar.clientHeight
            tar.style["height"] = `${tar.scrollHeight + borderH}px`
            //tar.style["height"] = `${tar.scrollHeight}px`
        },
        keydowned(e){
            if(!this.acceptWrap && e.key == "Enter"){
                e.preventDefault()
            }
        },
    },
}
</script>

